import { FileModel } from '@shared';

export abstract class TransferOutStragegy {
	public abstract validate(
		environment: string,
		businessUnit?: string,
		dhlLoggingStyle?: string,
		sstnLoggingStyle?: string,
		externalTransferId?: string
	): Promise<FileModel>;
}
